import type { ReactNode } from 'react';
import styles from './Error.module.less';
import MetricFacet from '../generic/MetricFacet';

export type Props = {
  label: ReactNode;
  message: ReactNode;
};

const ErrorFacet = ({
  label,
  message,
}: Props) => {
  return (
    <MetricFacet>
      <MetricFacet.Total>Error</MetricFacet.Total>
      <MetricFacet.Label>{label}</MetricFacet.Label>
      <MetricFacet.Legend>
        <div className={styles.legend}>{message}</div>
      </MetricFacet.Legend>
    </MetricFacet>
  );
};

export default ErrorFacet;
